import { COVERAGE } from '../data/fleet'

export default function Coverage() {
  return (
    <section className="section section--tight" id="coverage">
      <div className="wrap coverage">
        <div>
          <span className="eyebrow">Delivery area</span>
          <h2>North metro, and a good way past it</h2>
          <p className="lede" style={{ marginTop: '1rem' }}>
            Pickup is open to anyone, anywhere &mdash; this list is where we
            deliver. Outside it, call anyway. Longer runs get quoted and we
            take them when the morning route allows.
          </p>
        </div>

        <ul className="coverage__list">
          {COVERAGE.map((city) => (
            <li key={city}>{city}</li>
          ))}
        </ul>
      </div>
    </section>
  )
}
